import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import { computed } from '@vue/composition-api';

import { TimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';

export function useCompetitionRouteParams() {
    const {
        route,
        router,
    } = useVueRouter();

    function ensureTimeFilterIsAll(): void {
        if (route.value.params?.timeFilter !== TimeFilterSlug.All) {
            router.value.replace({
                name: route.value.name!,
                params: {
                    ...route.value.params,
                    timeFilter: TimeFilterSlug.All,
                },
                query: route.value.query,
            });
        }
    }

    return {
        sportSlug: computed(() => route.value.params.sportSlug),
        categorySlug: computed(() => route.value.params.categorySlug),
        tournamentSlug: computed(() => route.value.params.tournamentSlug),
        ensureTimeFilterIsAll,
    };
}
